import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "Auth.AuthSelectPhoneForm.title",
    defaultMessage:
      "Which number should we send your login confirmation code to?",
  },
});
